module.exports = __webpack_public_path__ + "static/img/c3.28f9902.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/cloud/c3.png
// module id = pSMp
// module chunks = 0